import { PaginatedLiabilityInsuranceQueryVariables } from "@/graphql/__generated__/graphql";
import DateRangeFilter from "../../Shared/DateRangeFilter";
import { format } from "date-fns";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables?: PaginatedLiabilityInsuranceQueryVariables) => void;
}

/**
 * LiabilityInsuranceDateRange component for filtering liability insurance by activeFrom date range
 * @param props Component properties
 * @returns JSX element
 */
function LiabilityInsuranceDateRange({ displayAmount, handleSubmitClick }: Props) {
  const liabilityInsuranceDateConfig = {
    paginationStateKey: "paginatedLiabilityInsurance" as keyof PaginationState,
    dateFieldName: "activeFrom",
    buildQueryVariables: (
      displayAmount: number,
      filters: any,
      dateRange: { gte: Date | null; lte: Date | null },
      sort?: any
    ): PaginatedLiabilityInsuranceQueryVariables => ({
      first: displayAmount,
      filters: {
        activeFrom: (dateRange.gte === null && dateRange.lte === null) ? null : {
          gte: dateRange.gte ? format(dateRange.gte, "yyyy-MM-dd") + "T00:00:00+00:00" : null,
          lte: dateRange.lte ? format(dateRange.lte, "yyyy-MM-dd") + "T23:59:59+00:00" : null,
        },
        liabilityInsurance: filters.liabilityInsurance || null,
        professionalAssociation: filters.professionalAssociation || null
      },
      sort: sort
    }),
    extractFilters: (paginationState: any) => ({
      activeFrom: paginationState.filters?.activeFrom,
      liabilityInsurance: paginationState.filters?.liabilityInsurance,
      professionalAssociation: paginationState.filters?.professionalAssociation,
    })
  };

  return (
    <DateRangeFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={liabilityInsuranceDateConfig}
    />
  );
}

export default LiabilityInsuranceDateRange;
